module.exports = __webpack_public_path__ + "img/8034fcd195b0c1abf5ea39568a01e58d.jpg";